import { Routes } from '@angular/router';

export const OBJECT_DEFINITIONS_SETTINGS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@tourfold/features/custom-objects/schema-builder').then((m) => m.ObjectDefinitionsListComponent),
  },
  {
    path: ':slug',
    loadComponent: () =>
      import('@tourfold/features/custom-objects/schema-builder').then((m) => m.ObjectDefinitionDetailComponent),
  },
];
